export enum MINT_ACTIONS {
  FETCH_CONFIGURATIONS_REQUEST = 'MINT_ACTIONS.FETCH_CONFIGURATIONS_REQUEST',
  FETCH_CONFIGURATIONS_SUCCESS = 'MINT_ACTIONS.FETCH_CONFIGURATIONS_SUCCESS',
  FETCH_CONFIGURATIONS_FAILURE = 'MINT_ACTIONS.FETCH_CONFIGURATIONS_FAILURE',
  SET_SELECTED_ASSET = 'MINT_ACTIONS.SET_SELECTED_ASSET',
  SET_SELECTED_WALLET = 'MINT_ACTIONS.SET_SELECTED_WALLET',
  SET_SELECTED_ID = 'MINT_ACTIONS.SET_SELECTED_ID',
  SET_SELECTED_BLOCKCHAIN_NETWORK = 'MINT_ACTIONS.SET_SELECTED_BLOCKCHAIN_NETWORK',
  SET_SETUP_LOADING = 'MINT_ACTIONS.SET_SETUP_LOADING',
  SET_SETUP_ERROR = 'MINT_ACTIONS.SET_SETUP_ERROR',
  RESET_SETUP = 'MINT_ACTIONS.RESET_SETUP',
  DISMISS_EDUCATIONAL_BANNER = 'MINT_ACTIONS.DISMISS_EDUCATIONAL_BANNER',
  FETCH_TRANSACTIONS_REQUEST = 'MINT_ACTIONS.FETCH_TRANSACTIONS_REQUEST',
  FETCH_TRANSACTIONS_SUCCESS = 'MINT_ACTIONS.FETCH_TRANSACTIONS_SUCCESS',
  FETCH_TRANSACTIONS_FAILURE = 'MINT_ACTIONS.FETCH_TRANSACTIONS_FAILURE',
  SET_TRANSACTION_FILTERS = 'MINT_ACTIONS.SET_TRANSACTION_FILTERS',
}
